import { graphqlApolloClient as client } from "../graphql-apollo-client"
import { GET_SUBMISSION_ALLIES } from "./graphql/queries/getSubmissionAllies"

export const getSubmissionAllies = async ({ id }) => {
  const { data } = await client.query({
    query: GET_SUBMISSION_ALLIES,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.Submission
}